module.exports = __webpack_public_path__ + "img/processor-3720053_1920.b6cbf70e.jpg";